// Permissions that only make sense when other permissions are also held.
// Keyed by permission Name (the claim key); the value lists the permission Names it depends on.
// Surfaced in the permission page so admins see the dependency instead of it being implicit.
export var PermissionDependencies = {
    // An operator is opened from the operators list, so editing one needs list access.
    "EditOperator": ["ListOperators"],
    // After creating an operator the app opens its edit screen, which needs edit access.
    "CreateOperator": ["EditOperator"],
    // A brand is opened from the brands list, so editing one needs list access.
    "EditBrands": ["ListBrands"],
    // After creating a brand the app opens its edit screen, which needs edit access.
    "CreateBrand": ["EditBrands"],
    // The brand lottery page is reached through the brand's Lotteries tab.
    "ManageBrandLottery": ["BrandLotteries"],
};
